/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const da_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const de_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const en_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const es_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const fr_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const hu_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const it_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const nl_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const pl_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const pt_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

const sv_attributes_power_supply = /** @type {(inputs: {}) => string} */ () => {
	return `Alimentation`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_power_supply = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_power_supply(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_power_supply", locale)
	if (locale === "cs") return cs_attributes_power_supply(inputs)
	if (locale === "da") return da_attributes_power_supply(inputs)
	if (locale === "de") return de_attributes_power_supply(inputs)
	if (locale === "en") return en_attributes_power_supply(inputs)
	if (locale === "es") return es_attributes_power_supply(inputs)
	if (locale === "fr") return fr_attributes_power_supply(inputs)
	if (locale === "hu") return hu_attributes_power_supply(inputs)
	if (locale === "it") return it_attributes_power_supply(inputs)
	if (locale === "nl") return nl_attributes_power_supply(inputs)
	if (locale === "pl") return pl_attributes_power_supply(inputs)
	if (locale === "pt") return pt_attributes_power_supply(inputs)
	return sv_attributes_power_supply(inputs)
};
export { attributes_power_supply as "attributes.power_supply" }